import React, { useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { TicketAttachment } from "@services/tickets/types";
import { useErrorNotification } from "@common/components/Notification";
import { deleteAttachment } from "@services/tickets";
import { FormContext } from "../context/formContext";
import Button from "@common/components/Button";

interface DeleteAttachmentDialogProps {
  open?: boolean;
  onClose?: () => void;
  attachmentId?: number;
}

const DeleteAttachmentDialog = (props: DeleteAttachmentDialogProps) => {
  const { form } = useContext(FormContext);
  const { details } = form;
  const { open = false, onClose = () => {}, attachmentId } = props;
  const { t } = useTranslation();
  const dispatchError = useErrorNotification();

  const onConfirm = async () => {
    try {
      await deleteAttachment(attachmentId ?? 0);

      let index = details?.attachments?.findIndex(
        (attachment: TicketAttachment) => attachment.id == attachmentId
      );
      if (index != -1) details?.attachments?.splice(index ?? 0, 1);

      onClose();
    } catch (e) {
      dispatchError(e);
    }
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>{t("Attachment")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("Please confirm you want to delete this attachment")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="white" onClick={onConfirm}>
          {t("Confirm")}
        </Button>
        <Button variant="outlined" color="greyed" onClick={onClose}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAttachmentDialog;
